<template>
	<div>
		<el-tabs v-model="activeName" @tab-click="handleClick">
			<el-tab-pane label="菜单分配" name="1">
				<div class="content_edit">
					<div class="content_edit_item">
						<button class="pre_btn_ok" @click="load_list_select()">
							刷新
						</button>&nbsp;
					</div>
				</div>
				<div class="content_edit">
					<div class="menu-edit content_edit_item" v-for="(item,index) in parm_sel" :key="index">
						<component :is="NextTickName(item.type)" :inData="checkJson(item)"
							@com-event="refresh_view_sel">
						</component>
					</div>
				</div>
				<div class="pre-tab">
					<table class="dataintable tab-inline" border="1" cellpadding="2" cellspacing="1">
						<thead>
							<tr>
								<th>序号</th>
								<th class="long1">一级菜单</th>
								<th class="long2">二级菜单</th>
								<th class="short0">是否拥有</th>
								<th class="short0">操作</th>
							</tr>
						</thead>
						<tbody class="tab_body">
							<tr v-for="(item, index) in menu_select" :key="index">
								<td>{{ item.row_num }}</td>
								<td class="long1">{{ item.one_name }}</td>
								<td class="long2">{{ item.two_name }}</td>
								<td class="short0 cen">{{checkHas( item.is_check )}}</td>
								<td class="short0 cen">
									<el-checkbox class="checkleft" v-model="item.is_has"
										v-on:change="select_menu(item)">
									</el-checkbox>
								</td>
							</tr>
						</tbody>
					</table>
					<table class="dataintable tab-inline" border="1" cellpadding="2" cellspacing="1">
						<thead>
							<tr>
								<th>序号</th>
								<th class="short1">姓名</th>
							</tr>
						</thead>
						<tbody class="tab_body">
							<tr v-for="(item, index) in list_user" :key="index">
								<td>{{ item.row_num }}</td>
								<td class="short1">{{ item.u_name }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</el-tab-pane>
			<el-tab-pane label="初始设置" name="2">
				<div class="content_edit">
					<div class="content_edit_item">
						<button class="pre_btn_ok" @click="load_db_data()">
							刷新
						</button>&nbsp;
						<button class="pre_btn_ok" @click="fun_upd('new')">
							新增
						</button>&nbsp;
						<button class="pre_btn_ok" @click="fun_upd('add')">
							保存
						</button>&nbsp;
						<button class="pre_btn_ok btn_del" @click="fun_upd('del')">
							删除
						</button>&nbsp;
						<button class="pre_btn_ok" @click="fun_sel_file()">
							选择文件
						</button>&nbsp;
						<button class="pre_btn_ok" @click="fun_look_file()">
							预览文件
						</button>&nbsp;
						<button class="pre_btn_ok btn_del" @click="fun_del_file()">
							删除文件
						</button>&nbsp;
						<button class="pre_btn_ok" @click="fun_up_file()">
							上传文件
						</button>
					</div>
				</div>
				<!-- 动态查询与编辑区生成 -->
				<div class="content_edit">
					<div class="content_edit_item tab-row" v-for="(r,d) in max_row" :key="d">
						<div class="content_edit_item" v-if="item.x == r.row" v-for="(item,index) in parm" :key="index">
							<!-- {{handleImportView(item)}} -->

							<component :is="NextTickName(item.type)" :inData="checkJson(item)"
								@com-event="refresh_view_all">
							</component>
						</div>
					</div>
					<div class="content_edit_item" v-show="file_show">
						<label>文件:</label>{{file_name}}&nbsp;&nbsp;{{file_up}}
					</div>
				</div>

				<!-- 主界面内容显示 start -->
				<pre-table ref="file_table" @tab-event="refresh_data" :api_url="load_url" :pre_post="load_json"
					:pre_post_upd="upd_json">
					<!-- 设定标题  -->
					<template slot="tab_title">
						<tr class="tab_header_new" :class="[isTwo=='1'?TwoNone:'']">
							<td>ID</td>
							<td v-for="(t,index) in parm_th" :key="index">{{t.name}}</td>
						</tr>
					</template>
					<template slot="tab_tr" slot-scope="user">
						<tr :id="'m_'+user.item[1].val" :class="[isTwo=='1'?TwoNone:'']"
							@click="sel_row(user.item,'all')">
							<!-- <a href="#"> -->
							<td v-for="(d,index) in user.item" :key="index"
								v-on:mousemove="show_detaildata($event, d.val, '1')" v-on:mouseout="noshow_detaildata">
								<div v-if="d.key=='img_url'">
									<el-image style="width: 20px; height: 20px" :src="check_url(d.val)"
										:preview-src-list="[check_url(d.val)]">
									</el-image>
								</div>
								<div v-else>{{d.val}}</div>
							</td>
							<!-- </a> -->
						</tr>
					</template>
					<!-- 构建新增模板 -->
					<template slot="tab_addorupdate">

					</template>
				</pre-table>

			</el-tab-pane>
			<el-tab-pane label="关联设定" name="3">
				<div class="content_edit">
					<div class="content_edit_item">
						<button class="pre_btn_ok" @click="load_list_one()">
							刷新
						</button>&nbsp;
					</div>
				</div>
				<div class="edit-area" v-loading="element_loading" element-loading-text="拼命加载中......"
					element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
					<div class="menu-left">
						<div class="menu-title">一级菜单编辑</div>
						<div class="menu-edit-all-l">
							<div class="menu-edit">
								<label>名称:</label><input type="text" v-model="m_one_name" />
							</div>
							<div class="menu-edit">
								<label>排序:</label><input type="number" v-model="m_one_step" class="short0"
									@keydown.enter="fun_menu_one_edit('add')" />
							</div>
							<div class="menu-edit">
								<button @click="fun_menu_one_edit('new')">新增</button>&nbsp;&nbsp;
								<button @click="fun_menu_one_edit('add')">保存</button>
							</div>
						</div>

						<table class="dataintable">

							<tbody>
								<tr>
									<th>序号</th>
									<th class="short1">名称</th>
									<th class="short0">排名</th>
									<th class="short0">状态</th>
									<th class="short0">修改人</th>
									<th class="long-date">更新日期</th>
									<th class="short0">编辑</th>
								</tr>
								<tr :id="'menu_one_'+item.row_num" v-for="(item, index) in menu_one" :key="index"
									@click="sel_menu_one(item,'edit')">
									<td>{{ item.id }}</td>
									<td class="short1">{{ item.menu_name }}</td>
									<td class="short0">{{ item.step }}</td>
									<td class="short0">{{item.flag}}</d>
									<td class="short0">{{item.u_name}}</td>
									<td class="long-date">{{item.sys_date}}</td>
									<td class="short0">
										<button @click="sel_menu_one(item,'del')">删除</button>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="menu-right">
						<div class="menu-title">二级菜单编辑</div>
						<div class="menu-edit-all-r">
							<div class="menu-edit">
								<label>一级菜单:</label><label>{{m_one_name}}</label>
							</div>

							<div class="menu-edit content_edit_item" v-for="(item,index) in parm_two" :key="index">
								<component :is="NextTickName(item.type)" :inData="checkJson(item)"
									@com-event="refresh_view_two">
								</component>
							</div>
							<div class="menu-edit">
								<label>排序:</label><input type="number" v-model="two_step" class="short0"
									@keydown.enter="fun_menu_two_edit('add')" />
							</div>
							<div class="menu-edit">
								<button @click="fun_menu_two_edit('add')">{{two_edit_label}}</button>
							</div>
						</div>

						<table class="dataintable">
							<tbody>
								<tr>
									<th>序号</th>
									<th class="long1">一级名称</th>
									<th class="long1">二级名称</th>
									<th class="short">排名</th>
									<th class="long1">修改人</th>
									<th class="long-date">更新日期</th>
									<th class="short0">编辑</th>
								</tr>
								<tr :id="'menu_two_'+item.row_num" v-for="(item, index) in menu_two" :key="index"
									@click="sel_menu_two(item,'edit')">
									<td>{{ item.id }}</td>
									<td class="long1">{{ item.one_name }}</td>
									<td class="left long1">{{ item.two_name }}</td>
									<td class="short">{{ item.step }}</td>
									<td class="long1">{{ item.u_name }}</td>
									<td class="long-date">{{ item.sys_date }}</td>
									<td class="short0">
										<button @click="sel_menu_two(item,'del')">删除</button>
									</td>
								</tr>
							</tbody>
						</table>

					</div>
				</div>

			</el-tab-pane>
			<el-tab-pane label="权限设定" name="4">
				<div class="content_edit">
					<div class="content_edit_item">
						<button class="pre_btn_ok" @click="load_list_selbtn()">
							刷新
						</button>&nbsp;
					</div>
				</div>
				<div class="content_edit">
					<div class="menu-edit content_edit_item" v-for="(item,index) in parm_sel" :key="index">
						<component :is="NextTickName(item.type)" :inData="checkJson(item)"
							@com-event="refresh_view_selbtn">
						</component>
					</div>
				</div>
				<table class="dataintable tab-inline" border="1" cellpadding="2" cellspacing="1">
					<thead>
						<tr>
							<th>序号</th>
							<th class="long1">一级菜单</th>
							<th class="long2">二级菜单</th>
							<th class="short0">新增</th>
							<th class="short0">删除</th>
							<th class="short0">修改</th>
							<th class="short0">查询</th>
							<th class="short0">提交</th>
							<th class="short0">作废</th>
							<th class="short0">导入</th>
							<th class="short0">导出</th>
							<th class="short0">附件上传</th>
							<th class="short0">附件预览</th>
							<th class="short0">附件删除</th>
						</tr>
					</thead>
					<tbody class="tab_body">
						<tr v-for="(item, index) in menu_selbtn" :key="index">
							<td>{{ item.row_num }}</td>
							<td class="long1">{{ item.one_name }}</td>
							<td class="long2">{{ item.two_name }}</td>
							<td class="short0 cen">
								<el-checkbox class="checkleft" v-model="item.btn_add"
									v-on:change="select_menubtn(item,'btn_add')">
								</el-checkbox>
							</td>
							<td class="short0 cen">
								<el-checkbox class="checkleft" v-model="item.btn_del"
									v-on:change="select_menubtn(item,'btn_del')">
								</el-checkbox>
							</td>
							<td class="short0 cen">
								<el-checkbox class="checkleft" v-model="item.btn_upd"
									v-on:change="select_menubtn(item,'btn_upd')">
								</el-checkbox>
							</td>
							<td class="short0 cen">
								<el-checkbox class="checkleft" v-model="item.btn_sel"
									v-on:change="select_menubtn(item,'btn_sel')">
								</el-checkbox>
							</td>
							<td class="short0 cen">
								<el-checkbox class="checkleft" v-model="item.btn_sub"
									v-on:change="select_menubtn(item,'btn_sub')">
								</el-checkbox>
							</td>
							<td class="short0 cen">
								<el-checkbox class="checkleft" v-model="item.btn_bad"
									v-on:change="select_menubtn(item,'btn_bad')">
								</el-checkbox>
							</td>
							<td class="short0 cen">
								<el-checkbox class="checkleft" v-model="item.btn_exl_up"
									v-on:change="select_menubtn(item,'btn_exl_up')">
								</el-checkbox>
							</td>
							<td class="short0 cen">
								<el-checkbox class="checkleft" v-model="item.btn_exl_down"
									v-on:change="select_menubtn(item,'btn_exl_down')">
								</el-checkbox>
							</td>
							<td class="short0 cen">
								<el-checkbox class="checkleft" v-model="item.btn_fileup"
									v-on:change="select_menubtn(item,'btn_fileup')">
								</el-checkbox>
							</td>
							<td class="short0 cen">
								<el-checkbox class="checkleft" v-model="item.btn_filedel"
									v-on:change="select_menubtn(item,'btn_filedel')">
								</el-checkbox>
							</td>
							<td class="short0 cen">
								<el-checkbox class="checkleft" v-model="item.btn_filelook"
									v-on:change="select_menubtn(item,'btn_filelook')">
								</el-checkbox>
							</td>
						</tr>
					</tbody>
				</table>

			</el-tab-pane>
			<el-tab-pane label="备注说明" name="5">
				<h5>1：按角色划分控制是否可见菜单</h5><br />
				<h5>2：一级菜单与二级菜单没有严格绑定</h5><br />
				<h5>3：控制按钮:增加、删除、修改、查询、增加、删除、修改、查询、提交、作废。</h5><br />
				<!-- <h5>说明4：批量权限控制,先选择角色范围,再选择具体控制,选择完成后点击保存进行修改。</h5> -->
				<h5>4：菜单名称8个汉字以内。</h5><br />
			</el-tab-pane>
		</el-tabs>

		<!-- 明细数据提示 -->
		<div id="pre_detail_data" style="display:none;">
			<p v-for="(item, index) in detail_data" :key="index">
				{{ item.name }}={{ item.amount }}
			</p>
		</div>
		<div id="pre_msg_data" style="display:none;"></div>
		<!-- 文件预览部分 -->
		<!-- 弹出向导层 预览 与 下载 start-->
		<input class="displayno" type="file" id="hetong_file" v-on:change="getFilePath" />

		<a id="downlink"></a>
		<a id="loodlink" target="_blank"></a>
	</div>
</template>

<script>
	import api from '@/utils/type.js';
	import {
		Sel_page_and_length,
		Method_Common,
		Method_EasySelect,
		Method_TableAll
	} from '@/utils/loadhttpdata.js';

	import {
		dateFormatbyChina,
		dateFormatToChina,
		Word_Right_Delete
	} from '@/utils/method.js';

	// 文件操作辅助方法
	import {
		base_encode,
		base_decode
	} from "@/utils/base64.js";
	import {
		GetShort,
		DeleteSpecialWord,
		BackSpecial,
		ChangeSpecial,
		GetRandom
	} from "@/utils/localstore.js";
	import {
		BrowserGet
	} from '@/utils/systemSelect.js';

	export default {
		components: {
			"pre-button": () => import("../per_mode/pre_btn_easy.vue"),
			"pre-table": () => import("../auto/auto_view_table.vue")
		},
		data() {
			return {
				element_loading: false,
				activeName: '1',
				show_second: false,
				show_five: false,

				list_menu_child: [],
				max_row: [],
				parm: [],
				parm_th: [],
				load_url: '',
				load_json: '',
				upd_json: '',
				nowpage: '1',
				page_length: 20, //add 2022-01-25 默认分页长度
				title: '未设置标题',
				sel_action: '',
				upd_action: '',
				check_key: '', //add 2022-02-15 结构匹配标识
				row_id: '',
				sys_date: '',
				// 定义默认样式
				isTwo: '1',
				TwoNone: 'last-two-none',

				detail_data: [],
				//文件
				file_list_main: [],
				/*add 2022-02-20 图片存储*/
				file_show: false,
				file_name: "",
				file_data: "",
				file_up: "",
				file_url: "",
				file_src: "",
				file_size: "0",
				file_action: '',
				blockSize: '',
				file_backdata: '',
				p1: '',
				p2: '',
				p3: '',

				m_one_name: '',
				m_one_step: '',
				menu_one: [],
				one_id: '',
				one_sys_date: '',

				two_edit_label: '新增',
				parm_two: [],
				menu_two: [],
				two_sel_name: '',
				two_id: '',
				two_step: '',
				two_sys_date: '',

				menu_select: [],
				r_id: '',
				parm_sel: [],
				list_user: [],

				menu_selbtn: []


			};
		},
		created: function() {

			// this.init_login();
			// this.init_sys();
			this.handleClick();
		},
		methods: {
			checkHas: function(val) {
				let t = '无';
				if (val == '2') {
					t = '有';
				}
				return t;
			},
			check_url: function(url) {
				let t = BackSpecial(url);
				// console.log(t);
				return t;
			},
			handleClick(tab, event) {
				let t = 0;
				if (typeof(tab) !== 'undefined' && tab.name !== 'undefined') {
					// console.log(tab.name, event);
					t = tab.name;
				}

				for (let i = 0; i < this.parm_sel.length; i++) {
					this.parm_sel[i].val = '';
				}

				switch (t) {
					case '1':
						this.initDataFirst();
						break;
					case '2':
						this.initDataSecond();
						break;
					case '3':
						this.initDataThird();
						this.load_list_one();
						break;
					case '4':
						this.load_list_selbtn();
						break;
					case '5':
						break;
					default:
						this.initDataFirst();
						break;

				}
			},
			initDataFirst: function() {
				/******************************************/
				this.parm_th = [];
				this.parm = [];

				this.max_row = [];
				this.row_id = '';
				this.sel_action = '';
				this.upd_action = '';
				this.sys_date = '';
				this.isTwo = '';
				this.file_action = '';
				this.p1 = "";
				this.p2 = "";
				this.p3 = "";

				this.parm_sel = [{
						"name": "角色",
						"val": "",
						"key": "r_name",
						"type": "select",
						"class": "long1",
						"sel_action": "_base_role",
						"sel_name": "",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "2"
					},
					{
						"name": "二级菜单",
						"val": "",
						"key": "one_name",
						"type": "select",
						"class": "long1",
						"sel_action": "_base_yd_menu_one",
						"sel_name": "",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "2"
					}
				]

				this.menu_select = [];
				this.list_user = [];
				this.load_list_select();
				this.load_list_user();

			},
			initDataSecond: function() {
				/******************************************/
				this.parm_th = [{
						"name": "序号"
					},
					{
						"name": "菜单名称"
					},
					{
						"name": "跳转参数"
					},
					{
						"name": "排列顺序"
					},
					{
						"name": "增加"
					},
					{
						"name": "删除"
					},
					{
						"name": "修改"
					},
					{
						"name": "查询"
					},
					{
						"name": "提交"
					},
					{
						"name": "作废"
					},
					{
						"name": "导入"
					}, {
						"name": "导出"
					},
					{
						"name": "上传附件"
					},
					{
						"name": "预览附件"
					},
					{
						"name": "删除附件"
					},
					{
						"name": "按钮图标"
					},
					{
						"name": "状态"
					},
					{
						"name": "修改人"
					},
					{
						"name": "路径1"
					},
					{
						"name": "路径2"
					},
					{
						"name": "更新时间"
					},
				];
				this.parm = [{
						"name": "名称",
						"val": "",
						"key": "menu_name",
						"type": "text",
						"class": "long1",
						"note": "菜单名称",
						"p": "1",
						"x": "1"
					}, {
						"name": "参数",
						"val": "",
						"key": "menu_value",
						"type": "text",
						"class": "long1",
						"note": "跳转参数",
						"p": "1",
						"x": "1"
					}, {
						"name": "顺序",
						"val": "",
						"key": "step",
						"type": "number",
						"class": "long1",
						"note": "排列顺序",
						"p": "1",
						"x": "1"
					},
					{
						"name": "新增",
						"val": "1",
						"key": "btn_add",
						"type": "radio",
						"class": "long1",
						"list": [{
							"id": "1",
							"val": "否"
						}, {
							"id": "2",
							"val": "是"
						}],
						"sel_action": "",
						"sel_name": "",
						"p": "1",
						"x": "2"
					},
					{
						"name": "删除",
						"val": "1",
						"key": "btn_del",
						"type": "radio",
						"class": "long1",
						"list": [{
							"id": "1",
							"val": "否"
						}, {
							"id": "2",
							"val": "是"
						}],
						"sel_action": "",
						"sel_name": "",
						"p": "1",
						"x": "2"
					},
					{
						"name": "修改",
						"val": "1",
						"key": "btn_upd",
						"type": "radio",
						"class": "long1",
						"list": [{
							"id": "1",
							"val": "否"
						}, {
							"id": "2",
							"val": "是"
						}],
						"sel_action": "",
						"sel_name": "",
						"p": "1",
						"x": "2"
					},
					{
						"name": "查询",
						"val": "1",
						"key": "btn_sel",
						"type": "radio",
						"class": "long1",
						"list": [{
							"id": "1",
							"val": "否"
						}, {
							"id": "2",
							"val": "是"
						}],
						"sel_action": "",
						"sel_name": "",
						"p": "1",
						"x": "2"
					},
					{
						"name": "提交",
						"val": "2",
						"key": "btn_sub",
						"type": "radio",
						"class": "long1",
						"list": [{
							"id": "1",
							"val": "否"
						}, {
							"id": "2",
							"val": "是"
						}],
						"sel_action": "",
						"sel_name": "",
						"p": "1",
						"x": "2"
					},
					{
						"name": "作废",
						"val": "2",
						"key": "btn_bad",
						"type": "radio",
						"class": "long1",
						"list": [{
							"id": "1",
							"val": "否"
						}, {
							"id": "2",
							"val": "是"
						}],
						"sel_action": "",
						"sel_name": "",
						"p": "1",
						"x": "2"
					},
					{
						"name": "导入",
						"val": "2",
						"key": "btn_exl_up",
						"type": "radio",
						"class": "long1",
						"list": [{
							"id": "1",
							"val": "否"
						}, {
							"id": "2",
							"val": "是"
						}],
						"sel_action": "",
						"sel_name": "",
						"p": "1",
						"x": "3"
					},
					{
						"name": "导出",
						"val": "2",
						"key": "btn_exl_down",
						"type": "radio",
						"class": "long1",
						"list": [{
							"id": "1",
							"val": "否"
						}, {
							"id": "2",
							"val": "是"
						}],
						"sel_action": "",
						"sel_name": "",
						"p": "1",
						"x": "3"
					},
					{
						"name": "上传附件",
						"val": "2",
						"key": "btn_fileup",
						"type": "radio",
						"class": "long1",
						"list": [{
							"id": "1",
							"val": "否"
						}, {
							"id": "2",
							"val": "是"
						}],
						"sel_action": "",
						"sel_name": "",
						"p": "1",
						"x": "3"
					},
					{
						"name": "预览附件",
						"val": "2",
						"key": "btn_filelook",
						"type": "radio",
						"class": "long1",
						"list": [{
							"id": "1",
							"val": "否"
						}, {
							"id": "2",
							"val": "是"
						}],
						"sel_action": "",
						"sel_name": "",
						"p": "1",
						"x": "3"
					},
					{
						"name": "删除附件",
						"val": "2",
						"key": "btn_filedel",
						"type": "radio",
						"class": "long1",
						"list": [{
							"id": "1",
							"val": "否"
						}, {
							"id": "2",
							"val": "是"
						}],
						"sel_action": "",
						"sel_name": "",
						"p": "1",
						"x": "3"
					}
				];

				this.max_row = [];
				for (let i = 1; i < this.parm.length; i++) {
					let o = {};
					o.row = i;
					this.max_row.push(o);
				}


				this.row_id = '';
				this.sel_action = 'exp_yd_menu_sel';
				this.upd_action = 'yd_menu_edit_';
				this.sys_date = '';
				this.isTwo = '1';
				this.file_action = 'yd_menu_two';
				this.p1 = "yd";
				this.p2 = "menu";
				this.p3 = "";
				this.load_db_data();
				/******************************************/
				/******************************************/
				/******************************************/
				/******************************************/
			},
			initDataThird: function() {
				/******************************************/
				this.parm_two = [{
					"name": "二级菜单",
					"val": "",
					"key": "two_name",
					"type": "select",
					"class": "long1",
					"sel_action": "_base_yd_menu_two",
					"sel_name": "",
					"p": "1",
					"w": "0",
					"r": "0",
					"x": "2"
				}]

			},
			NextTickName: function(key) {
				return 'pre' + key;
			},
			checkJson: function(d) {
				let temp = '';
				temp = JSON.stringify(d)
				return temp;
			},
			refresh_view_all: function(d, type) {
				// console.log(d);
				for (let i = 0; i < this.parm.length; i++) {
					if (this.parm[i].key == d.key) {
						if (this.parm[i].type == 'select' || this.parm[i].type == 'radio') {
							this.parm[i].val = d.val;
							this.parm[i].sel_name = d.sel_name;
							break;
						} else {
							this.parm[i].val = d.val;
							break;
						}
					}
				}

				if (type == 'save') {
					this.sys_date = '';
					this.fun_upd('_add');
				}
			},
			refresh_view_two: function(d, type) {
				// console.log(d);
				for (let i = 0; i < this.parm_two.length; i++) {
					if (this.parm_two[i].key == d.key) {
						if (this.parm_two[i].type == 'select' || this.parm_two[i].type == 'radio') {
							this.parm_two[i].val = d.val;
							this.parm_two[i].sel_name = d.sel_name;
							break;
						} else {
							this.parm_two[i].val = d.val;
							break;
						}
					}
				}
			},
			refresh_view_sel: function(d, type) {
				// console.log(d);
				for (let i = 0; i < this.parm_sel.length; i++) {
					if (this.parm_sel[i].key == d.key) {
						if (this.parm_sel[i].type == 'select' || this.parm_sel[i].type == 'radio') {
							this.parm_sel[i].val = d.val;
							this.parm_sel[i].sel_name = d.sel_name;
							break;
						} else {
							this.parm_sel[i].val = d.val;
							break;
						}
					}
				}

				switch (d.key) {
					case 'r_name':
						this.r_id = d.val;
						this.load_list_user();
						break;
					case 'one_name':
						this.one_id = d.val;
						break
				}
				this.load_list_select();

			},
			refresh_view_selbtn: function(d, type) {
				console.log(d);
				for (let i = 0; i < this.parm_sel.length; i++) {
					if (this.parm_sel[i].key == d.key) {
						if (this.parm_sel[i].type == 'select' || this.parm_sel[i].type == 'radio') {
							this.parm_sel[i].val = d.val;
							this.parm_sel[i].sel_name = d.sel_name;
							break;
						} else {
							this.parm_sel[i].val = d.val;
							break;
						}
					}
				}

				switch (d.key) {
					case 'r_name':
						this.r_id = d.val;
						this.load_list_user();
						break;
					case 'one_name':
						this.one_id = d.val;
						break
				}
				this.load_list_selbtn();

			},
			load_db_data: function() {
				// console.log('全条件查询====');
				let kw1 = '',
					kw2 = '',
					kw3 = '';
				for (let i = 0; i < this.parm.length; i++) {
					let t = 0;
					t = i + 1 + '';
					switch (t) {
						case '1':
							kw1 = this.parm[i].val;
							break;
						case '2':
							kw2 = this.parm[i].val;
							break;
						case '3':
							kw3 = this.parm[i].val;
							break;
					}
				}

				let that = this;
				let r = (Math.random() + '').substring(0, 8);
				setTimeout(function() {
					that.load_url = api.http_method;
					that.load_json = Sel_page_and_length(that.sel_action, that.nowpage, that.page_length, kw1,
						kw2, kw3, '', '', r);
				}, 200);
			},
			refresh_data: function(type, page, pagelength, backdata) {
				// console.log('查询刷新=' + type + ' page=' + page + ' pagelength=' + pagelength);
				// console.log(backdata);
				// PAGE_LENGTH_CHANGE 改变分页长度,刷新加载

				if (type == 'PAGE_LENGTH_CHANGE') {
					this.nowpage = page;
					this.page_length = pagelength;
					this.load_db_data();
					return;
				}

				if (type == 'IMAGE_LIST' && backdata.length > 0) {
					this.file_list_main = [];
					this.file_list_main = backdata;
					return;
				}
				// let r = (Math.random() + '').substring(0, 8);

				let back = null;
				if (typeof(backdata) != "undefined" && backdata != '') {
					back = JSON.parse(backdata);
					// console.log(back);
					// console.log('new_id=' + back.new_id);
					this.row_id = back.new_id;
					this.sheet_flag = back.msg;
					// 同步关键参数便于后续修改
					this.sys_date = back.sys_date;
					this.sheet_no = back.sheet_no;
					for (let i = 0; i < this.parm.length; i++) {
						if (this.parm[i].key == 'sheet_no') {
							this.parm[i].val = this.sheet_no;
							break;
						}
					}

					this.element_loading = true;
					let r = (Math.random() + '').substring(0, 8);
					this.$post(
						api.http_method, Sel_page_and_length(this.sel_action, 1, 1, 'ID' + this.row_id, '', '', '',
							'', '', '',
							'', '', '', '', '', r)
					).then(res => {
						res = JSON.parse(res);

						this.element_loading = false;
						let res_page = [];
						res_page = res[0][0];

						if (res_page.flag == 1) {
							let bd = [];
							// console.log('allcount='+res_page.all_count)
							if (res_page.all_count > 0) {
								let t_list_data = res[1];
								// console.log(t_list_data);
								for (let i = 0; i < t_list_data.length; i++) {
									let arr = [];
									for (let j in t_list_data[i]) {
										let o = {};
										o.key = j;
										let temp_str = '';
										temp_str = t_list_data[i][j];
										if (typeof(temp_str) === 'string' && temp_str.indexOf("\\r\\n") > 0) {
											temp_str = ReplaceAll(temp_str, '\r\n', "<br/>");
											temp_str = ReplaceAll(temp_str, '\n', "<br/>");
											temp_str = temp_str.replace("\\r\\n", "\r\n");
											temp_str = temp_str.replace("\\n", "\n");
										}
										o.val = temp_str;
										arr.push(o);
									}
									bd.push(arr);
								}
							}

							this.sel_row(bd[0], 'edit');

						} else {
							this.$message({
								message: '编辑数据更新失败! \r\n ' + res.data.msg,
								type: 'success'
							});
						}

					});

				}

				if (Number(page) > 0) {

					// 更新编辑信息
					this.load_db_data();
					return;
				}

				//如果弹出编辑界面，有非编辑内容。应该查询一下，进行更新

			},
			sel_row: function(item, type) {
				// console.log(item);
				// console.log('type=' + type);
				// 判断 obj.hasOwnProperty("key")
				//2、遍历Json串获取其属性
				for (let i = 0; i < item.length; i++) {
					switch (item[i].key) {
						case 'id':
							this.row_id = item[i].val;
							break;
						case 'flag':
							this.sheet_flag = item[i].val;
							break;
						case 'sys_date':
							this.sys_date = item[i].val;
							break;
						case 'sheet_no':
							this.sheet_no = item[i].val;
							break;
						case 'f_url':
							let tt = BackSpecial(item[i].val);
							tt = tt.substring(tt.lastIndexOf('/') + 1);
							this.file_name = tt;
							this.file_url = item[i].val;
							if (this.file_name != '') {
								this.file_show = true;
							}
							break;
						case 'f_src':
							this.file_src = item[i].val;
							break;
						default:
							break;
					}
				}

				for (let i = 0; i < item.length; i++) {
					for (let j = 0; j < this.parm.length; j++) {
						if (this.parm[j].key == item[i].key) {
							if (this.parm[j].type == 'select' || this.parm[j].type == 'radio') {
								// console.log(this.parm[j]);
								this.parm[j].val = '';
								this.parm[j].sel_name = item[i].val;
							} else {
								this.parm[j].val = item[i].val;
							}

						}
					}
				}
				// console.log(this.parm)
				// 兼容老模式，通过隐藏最后一列来 保存路径，仅限报表查询使用
				if (this.isTwo == '1') {
					for (let i = 0; i < item.length; i++) {
						switch (item[i].key) {
							case 'f_url':
								let tt = BackSpecial(item[i].val);
								this.file_url = BackSpecial(tt);
								console.log(this.file_url);
								tt = tt.substring(tt.lastIndexOf('/') + 1);
								this.file_name = tt;
								if (this.file_name != '') {
									this.file_show = true;
								}
								break;
							default:
								break;
						}
					}
				}


				// 给父组件传点的 row_id，
				this.$emit('base2-event', '', this.row_id, item);
				// 切换背景色
				//       if (type != 'edit') {
				//         this.$refs.file_table.setCurrentRowJson('m_', item[1].val);
				//       }

				if (type == 'edit' || type == 'all') {
					this.$refs.file_table.setCurrentRowJsonOld('m_', item[1].val);
				}

				// console.log('选择 ID=' + this.row_id + ' sys_date=' + this.sys_date);



			},
			data_clear: function() {
				// console.log('清除 历史 参数。。。。');

				this.row_id = '';
				// 文件名称、路径、储存 选择确定
				this.sheet_flag = '';
				this.sheet_no = '';

				this.file_name = '';
				this.file_url = '';
				this.file_src = '';

				for (let j = 0; j < this.parm.length; j++) {
					if (this.parm[j].type == 'select') {
						this.parm[j].val = '';
						this.parm[j].sel_name = '';
					} else {
						this.parm[j].val = '';
					}

				}

				for (let j = 0; j < this.parm.length; j++) {
					if (typeof(this.parm[j].type) != 'undefined' && this.parm[j].type == 'select') {
						this.parm[j].val = '';
						this.parm[j].sel_name = '';
					} else {
						this.parm[j].val = '';
					}

				}

				// console.log('===END============')
			},
			fun_upd: async function(type) {
				// console.log('操作类型=' + type + ' row_id=' + this.row_id);
				if (type == '_upd') {
					if (this.row_id == 0) {
						this.$message({
							message: '请选择要修改的数据!',
							type: 'warning'
						});
						return;
					}
				}

				if (type == '_add') {
					let stop = false;
					let temp_name = '';
					for (let i = 0; i < this.parm.length; i++) {
						// console.log(this.parm[i]);
						if (this.parm[i].p == '1' && this.parm[i].weight == '1' && this.parm[i].val == '') {
							stop = true;
							temp_name = this.parm[i].name;
							break;
						}
					}
					if (stop) {
						this.$message({
							message: temp_name + '不能为空!',
							type: 'warning'
						});
						return;
					}
				}

				// 数据格式检查
				// //console.log('检查前', this.parm);
				for (let i = 0; i < this.parm.length; i++) {
					// //console.log(this.parm[i].val);
					if (this.parm[i].p == '1') {
						let temp = '';
						if (this.parm[i].type == 'time' || this.parm[i].type == 'datetime') {
							temp = dateFormatbyChina(this.parm[i].val);
						} else if (this.parm[i].type == 'selectnew') {
							//console.log(this.parm[i].key + '下拉选项', this.parm[i])
							if (typeof(this.parm[i].val) === 'number' && Number(this.parm[i].val) > 0) {
								temp = this.parm[i].val;
							} else {
								temp = '0';
								for (let j = 0; j < this.parm[i].list.length; j++) {
									if (this.parm[i].list[j].val == this.parm[i].sel_name) {
										temp = this.parm[i].list[j].id;
									}
								}
							}

						} else if (this.parm[i].type == 'select') {
							// //console.log(this.parm[i].key + '下拉选项', this.parm[i])
							if (typeof(this.parm[i].val) === 'number' && Number(this.parm[i].val) > 0) {
								temp = this.parm[i].val;
							} else if (typeof(this.parm[i].list) !== 'undefined' && this.parm[i].list.length > 0) {
								temp = '0';
								let tlist = this.parm[i].list;
								for (let j = 0; j < tlist.length; j++) {
									if (tlist[j].val == this.parm[i].sel_name) {
										temp = tlist[j].id;
									}
								}
							} else {
								temp = '0';
								let t_action = this.parm[i].sel_action;
								let res = await this.loadClass(t_action);
								// //console.log(res);
								if (res.status == '1') {
									let tlist = res.data;
									for (let j = 0; j < tlist.length; j++) {
										if (tlist[j].val == this.parm[i].sel_name) {
											temp = tlist[j].id;
										}
									}
								}

							}

						} else {
							temp = this.parm[i].val;
						}

						this.parm[i].val = temp;
					}
				}
				// console.log('检查前', this.parm);


				let d = [];
				for (let i = 0; i < this.parm.length; i++) {
					// console.log(this.parm[i].val);
					if (this.parm[i].p == '1') {

						if (this.parm[i].type == 'time' || this.parm[i].type == 'datetime') {
							d.push(dateFormatbyChina(this.parm[i].val));
						} else if (this.parm[i].type == 'textarea') {
							// console.log(this.parm[i].val);
							let str = '';
							str = this.parm[i].val;
							// let str = this.parm[i].val;
							str = str.replace(/\n/g, '<br/>');
							str = str.replace(/\s/g, '&nbsp;');
							d.push(str);
						} else {
							// console.log(this.parm[i].val);
							d.push(this.parm[i].val);
						}
					}
				}
				// console.log(d);
				// console.log(this.upd_action);

				let r = (Math.random() + '').substring(0, 8);

				this.upd_json = Method_Common('data_' + this.upd_action + type, this.row_id, this.sys_date, d,
					r);


			},
			loadClass: function(action, p1, p2, p3) {
				let that = this;
				return new Promise((resolve, reject) => {
					// //console.log(menuvalue);
					that.$post(
						api.http_method, Method_EasySelect(action, p1, p2, p3)
					).then(res => {
						res = JSON.parse(res);
						// //console.log(res.data);
						resolve(res.data)
					});

				});
			},
			show_detaildata: function(that, item, type) {
				if (BackSpecial(item).indexOf('http://') >= 0) {
					// 图片链接不悬浮显示
					return;
				}
				var x = 0,
					y = 0,
					temp_css = '';
				// console.log('明细数据显示坐标 ' + x + ' ' + y);
				// console.log(that);
				x = that.pageX + 10;
				y = that.pageY;

				var screenWidth = $(window).width();
				var screenHeight = $(window).height(); //当前浏览器窗口的 宽高
				// var scrolltop = $(document).scrollTop();//获取当前窗口距离页面顶部高度

				// console.log('页面宽度=' + screenWidth + '页面高度=' + screenHeight);
				// console.log('明细数据显示坐标 ' + x + ' ' + y);

				if ((x + 140) > screenWidth) {
					x = x - 160;
				}

				temp_css = "display: block;position: absolute;top:" + y + "px;left:" + x +
					"px;background-color: #99CCFF;border: 1px solid black;padding-left: 20px;padding-right: 20px;border-radius: 5px;z-index: 99999;";
				if (type == "0" && item.detail_data.length > 0) {
					this.detail_data = item.detail_data;
					// console.log($('#pre_detail_data'));
					document.getElementById("pre_detail_data").style.cssText = temp_css;
				}
				if (type == "1" && item != '') {
					temp_css += "max-width: 600px;word-break: break-all;padding-top: 5px;padding-bottom: 5px;";

					let temp_innerHtml = '';
					temp_innerHtml = BackSpecial(item);
					temp_innerHtml = temp_innerHtml.replace(/\r\n/g, "<br/>").replace(/\n/g, "<br/>")

					document.getElementById("pre_msg_data").innerHTML = temp_innerHtml;
					document.getElementById("pre_msg_data").style.cssText = temp_css;
				}
			},
			noshow_detaildata: function() {
				// console.log('不显示明细');
				document.getElementById("pre_detail_data").style.display = 'none';
				document.getElementById("pre_msg_data").style.display = 'none';
			},
			/****第一部分***********************************************/
			fun_menu_one_edit: function(type) {
				if (type == 'new') {
					this.one_id = 0;
					this.one_sys_date = '';
				}
				let d = [];
				d.push(this.m_one_name);
				d.push(this.m_one_step);

				let r = (Math.random() + '').substring(0, 8);
				// console.log(d);
				let temp_data = '';
				temp_data = Method_Common('yd_menu_one_' + type, this.one_id, this
					.one_sys_date, d, r);

				this.$post(
					api.http_method, temp_data
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					console.log('一级菜单', res);
					if (res.data.status == 1) {
						this.$message({
							message: res.data.msg,
							type: 'success'
						});
						this.one_id = res.data.parm.id;
						this.one_sys_date = res.data.parm.sys_date;
						this.load_list_one(); //
					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning'
						});
					}
				});
			},
			load_list_one: function() {
				this.element_loading = true;
				this.menu_one = [];
				let r = (Math.random() + '').substring(0, 8);
				this.$post(
					api.http_method, Sel_page_and_length('exp_yd_menu_one', 1, 100, '', r)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					if (res.length > 0) {
						let arr = res[0];
						// console.log(item);

						for (let i = 0; i < arr.length; i++) {
							let o = {};
							o = arr[i];
							o.row_num = i + 1;
							this.menu_one.push(o);
						}
						// console.log(this.menu_one);
					} else {
						this.$message({
							message: '没有查询到一级菜单!',
							type: 'warning'
						});
					}
				});
			},
			sel_menu_one: function(item, type) {
				this.one_id = item.id;
				this.one_sys_date = item.sys_date;
				this.m_one_name = item.menu_name;
				this.m_one_step = item.step;

				this.two_edit_label = '新增';
				this.two_id = '';
				this.two_sys_date = '';

				switch (type) {
					case 'edit':
						for (var i = 0; i < this.menu_one.length; i++) {
							// console.log(this.data_tab[i]);
							if (this.menu_one[i].row_num == item.row_num) {
								document.getElementById('menu_one_' + item.row_num).style.background = '#92a4f3';
							} else {
								if (this.menu_one[i].row_num % 2 == 0) {
									document.getElementById('menu_one_' + this.menu_one[i].row_num).style.background =
										'#fff';
								} else {
									document.getElementById('menu_one_' + this.menu_one[i].row_num).style.background =
										'#f5f5f5';
								}
							}
						}
						this.load_list_two();
						break;
					case 'del':
						this.fun_menu_one_edit('del');
						break;
					default:
						break;
				}

			},
			fun_menu_two_edit: function(type) {
				let d = [];
				d.push(this.one_id);
				d.push(this.parm_two[0].val);
				d.push(this.two_step);

				let r = (Math.random() + '').substring(0, 8);
				// console.log(d);
				let temp_data = '';
				temp_data = Method_Common('yd_menu_two_' + type, this.two_id, this
					.two_sys_date, d, r);

				this.$post(
					api.http_method, temp_data
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					console.log('一级菜单', res);
					if (res.data.status == 1) {
						this.$message({
							message: res.data.msg,
							type: 'success'
						});
						this.two_id = res.data.parm.id;
						this.two_sys_date = res.data.parm.sys_date;
						this.load_list_two(); //
					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning'
						});
					}
				});

			},
			load_list_two: function() {
				this.element_loading = true;
				this.menu_two = [];
				let r = (Math.random() + '').substring(0, 8);
				this.$post(
					api.http_method, Sel_page_and_length('exp_yd_menu_two', 1, 100, this.one_id, r)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					if (res.length > 0) {
						let arr = res[0];
						for (let i = 0; i < arr.length; i++) {
							let o = {};
							o = arr[i];
							o.row_num = i + 1;
							this.menu_two.push(o);
						}
						// console.log(this.menu_two);
					} else {
						this.$message({
							message: '没有查询到一级菜单' + this.m_one_name + ' 所属二级菜单!',
							type: 'warning'
						});
					}
				});
			},
			sel_menu_two: function(item, type) {
				this.two_id = item.id;
				this.two_sys_date = item.sys_date;
				this.parm_two[0].val = '';
				this.parm_two[0].sel_name = item.two_name;
				this.two_step = item.step;
				this.two_edit_label = '保存';
				console.log(this.parm_two[0]);

				switch (type) {
					case 'edit':
						for (var i = 0; i < this.menu_two.length; i++) {
							// console.log(this.data_tab[i]);
							if (this.menu_two[i].row_num == item.row_num) {
								document.getElementById('menu_two_' + item.row_num).style.background = '#92a4f3';
							} else {
								if (this.menu_two[i].row_num % 2 == 0) {
									document.getElementById('menu_two_' + this.menu_two[i].row_num).style.background =
										'#fff';
								} else {
									document.getElementById('menu_two_' + this.menu_two[i].row_num).style.background =
										'#f5f5f5';
								}
							}
						}
						break;
					case 'del':
						this.fun_menu_two_edit('del');
						break;
					default:
						break;
				}

			},
			/****关联设定部分***********************************************/
			load_list_select: function() {
				this.element_loading = true;
				this.menu_select = [];
				let r = (Math.random() + '').substring(0, 8);
				this.$post(
					api.http_method, Sel_page_and_length('exp_yd_menu_select', 1, 100, this.r_id, this.one_id, r)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					if (res.length > 0) {
						let arr = res[0];
						for (let i = 0; i < arr.length; i++) {
							let o = {};
							o = arr[i];
							o.row_num = i + 1;

							o.is_has = (arr[i].is_check == '1' ? false : true);
							this.menu_select.push(o);
						}
						// console.log(this.menu_select);
					} else {
						this.$message({
							message: '没有查询到内容!',
							type: 'warning'
						});
					}
				});
			},
			load_list_user: function() {
				this.element_loading = true;
				if (typeof(this.r_id) == 'undefined' || Number(this.r_id) == 0) {
					return;
				}
				this.list_user = [];
				let r = (Math.random() + '').substring(0, 8);
				this.$post(
					api.http_method, Sel_page_and_length('exp_yd_list_user', 1, 100, this.r_id, this.one_id, r)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					if (res.length > 0) {
						let arr = res[0];
						for (let i = 0; i < arr.length; i++) {
							let o = {};
							o = arr[i];
							o.row_num = i + 1;
							this.list_user.push(o);
						}
						console.log(this.list_user);
					} else {
						this.$message({
							message: '没有查询到内容!',
							type: 'warning'
						});
					}
				});
			},
			select_menu: function(row) {
				console.log(row);
				if (typeof(this.r_id) == 'undefined' || Number(this.r_id) == 0) {
					this.$message({
						message: '请选择一个角色!',
						type: 'warning'
					});
					return;
				}
				let d = [];
				d.push(this.r_id);
				d.push(row.is_check);

				let r = (Math.random() + '').substring(0, 8);
				// console.log(d);
				let temp_data = '';
				temp_data = Method_Common('yd_menu_row_has', row.id, '', d, r);

				this.$post(
					api.http_method, temp_data
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					console.log('一级菜单', res);
					if (res.data.status == 1) {
						this.$message({
							message: res.data.msg,
							type: 'success'
						});

						// this.load_list_select(); //
					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning'
						});
					}
				});
			},
			/****权限菜单设定***********************************************/
			load_list_selbtn: function() {
				if (typeof(this.r_id) == 'undefined' || Number(this.r_id) == 0) {
					this.$message({
						message: '请选择一个角色!',
						type: 'warning'
					});
					return;
				}

				this.element_loading = true;
				this.menu_selbtn = [];
				let r = (Math.random() + '').substring(0, 8);
				this.$post(
					api.http_method, Sel_page_and_length('exp_yd_menu_selbtn', 1, 100, this.r_id, this.one_id, r)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);

					if (res.length > 0) {
						let arr = res[0];
						// console.log(arr);
						for (let i = 0; i < arr.length; i++) {
							let o = {};
							o = arr[i];
							o.id = arr[i].id;
							o.row_num = i + 1;

							o.one_name = arr[i].one_name;
							o.two_name = arr[i].two_name;

							o.btn_add = (arr[i].btn_add == '1' ? false : true);
							o.btn_del = (arr[i].btn_del == '1' ? false : true);
							o.btn_upd = (arr[i].btn_upd == '1' ? false : true);
							o.btn_sel = (arr[i].btn_sel == '1' ? false : true);

							o.btn_sub = (arr[i].btn_sub == '1' ? false : true);
							o.btn_bad = (arr[i].btn_bad == '1' ? false : true);
							o.btn_exl_down = (arr[i].btn_exl_down == '1' ? false : true);
							o.btn_exl_up = (arr[i].btn_exl_up == '1' ? false : true);
							// o.btn_print = (arr[i].btn_print == '1' ? false : true);
							o.btn_fileup = (arr[i].btn_fileup == '1' ? false : true);
							o.btn_filelook = (arr[i].btn_filelook == '1' ? false : true);
							o.btn_filedel = (arr[i].btn_filedel == '1' ? false : true);


							this.menu_selbtn.push(o);
						}
						// console.log(this.menu_selbtn);
					} else {
						this.$message({
							message: '没有查询到内容!',
							type: 'warning'
						});
					}
				});
			},
			select_menubtn: function(row, btn_key) {
				// console.log(row.id+' = '+btn_key);
				if (typeof(this.r_id) == 'undefined' || Number(this.r_id) == 0) {
					this.$message({
						message: '请选择一个角色!',
						type: 'warning'
					});
					return;
				}
				let d = [];
				d.push(this.r_id);
				d.push('');
				d.push(btn_key);

				let r = (Math.random() + '').substring(0, 8);
				// console.log(d);
				let temp_data = '';
				temp_data = Method_Common('yd_menu_row_hasbtn', row.id, row.sys_date, d, r);

				this.$post(
					api.http_method, temp_data
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log('一级菜单', res);
					if (res.data.status == 1) {
						this.$message({
							message: res.data.msg,
							type: 'success'
						});

						// this.load_list_select(); //
					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning'
						});
					}
				});
			},

			/****权限按钮设定***********************************************/
			// 点击上传附件
			fun_sel_file: function() {
				// console.log('点击选择附件=' + this.row_id);
				this.file_name = '';
				this.file_url = '';
				this.file_src = '';
				this.file_data = '';
				this.file_backdata = '';

				if (this.row_id == null || Number(this.row_id) == 0) {
					this.$message({
						dangerouslyUseHTMLString: true,
						message: '操作不正确,请选择需要上传附件<div class="mtop mdown" > 项目名称ID=0</div>请检查!'
					});
					return;
				}
				// console.log(this.file_url);
				if (this.file_url != '') {
					this.$message({
						dangerouslyUseHTMLString: true,
						message: '操作不正确,已经上传附件<div class="mtop mdown" > 名称=' + this.file_name + '</div>请检查!'
					});
					return;
				}

				let fileobj = document.getElementById('hetong_file');

				// document.selection.clear(); //清空附件选择 测试无效！
				fileobj.value = '';
				// fileobj.outerHTML = fileobj.outerHTML; //重新初始化了fileobj的html
				fileobj.click();

			},
			fun_look_file: function() {
				console.log('点击预览附件');
				// console.log(this.parm);
				// 可以通过判断附件数量大于1时,通过小弹出进行编辑操作

				if (this.file_url == null || String(this.file_url).length == 0 || String(this.file_url) == '') {
					this.$message({
						dangerouslyUseHTMLString: true,
						message: '请确定选择单据已经上传附件<div class="mtop mdown" > 合同名称=' + this.f_name + '</div>请检查!'
					});
					return;
				}

				if (/\.(gif|jpg|jpeg|png|ico|pdf)$/.test(this.file_name.toLowerCase())) {
					// 会被火狐浏览器弹窗阻止,360和谷歌正常
					this.pdfview = document.getElementById('loodlink');
					this.pdfview.href = this.file_url;
					// window.open(tv_url, '_blank'); //被弹窗阻止
					this.pdfview.click();
				} else {
					this.$message({
						message: '该类型文件暂不支持预览,将开始下载!',
						type: 'success'
					});

					let down_file = document.getElementById("downlink");
					let temp_url = BackSpecial(this.file_url);
					let temp_filename = BackSpecial(BackSpecial(temp_url.substring(temp_url.lastIndexOf('/') + 1)));
					down_file.download = this.file_name; // 下载名称
					down_file.href = temp_url; // 绑定a标签
					down_file.click(); // 模拟点击实现下载
				}
			},
			getFilePath: function() {
				let tmpFile = document.getElementById('hetong_file');
				// console.log('点击选择结果');
				// console.log(tmpFile.files);
				if (typeof FileReader !== "undefined") {
					let max_size = 20000; // 50k 20M
					let name = '';
					let size = 0;
					let fileData = tmpFile.files[0];
					this.file_backdata = fileData;
					name = fileData.name;
					size = fileData.size;
					// console.log('名称=' + name + ' 大小=' + size);
					if (!(/\.(gif|jpg|jpeg|png|ico|pdf|doc|docx|zip|rar)$/.test(name.toLowerCase()))) {
						this.$message({
							message: '只可以上传图片、pdf、doc、docx、zip、rar格式',
							type: 'warning'
						});
						return;
					}
					this.file_name = name;
					this.file_show = true;
					if (size > max_size * 1024) {
						this.$message({
							message: '图片大小不能超过2M',
							type: 'warning'
						});
						return
					}
					// console.log(tmpFile);   //连标签原样输出了
					// console.log(tmpFile.value);   //图片路径


					let reader = new FileReader(); // FileReader
					let that = this;
					reader.readAsDataURL(fileData);
					reader.onload = function() {
						// 获取到base64图片内容
						that.file_data = this.result;
					}
					// console.log(size / 1024 + 'kB');
				} else {
					this.$message({
						message: '当前浏览器不支持上传组件',
						type: 'warning'
					});
				}

			},
			fun_del_file: function() {
				console.log('点击删除附件' + this.sheet_flag);
				if (this.sheet_flag == '完成' || this.sheet_flag == '已提交') {
					this.$message({
						message: '单据已经完成,不能删除附件!',
						type: 'warning'
					});
					return;
				}

				if (this.file_url == '') {
					this.$message({
						dangerouslyUseHTMLString: true,
						message: '请确定选择单据已经上传附件<div class="mtop mdown" > 名称=' + this.file_name + '</div>请检查!'
					});
					return;
				}

				// 第一步 删除存储路径
				this.fun_del_file_two();
				// 第二步 删除真实文件
				this.fun_del_file_three(this.file_src);
			},
			fun_del_file_two: function() {
				var postdata = "";

				postdata =
					'{"action":"' + this.file_action + '_del","user_no":"' +
					GetShort("userno") +
					'","sheet_no":"' +
					this.sheet_no +
					'","rowid":"' +
					this.row_id +
					'"}';



				// //console.log(postdata);
				postdata =
					'{"method":"File_load","data":"' + base_encode(postdata) + '"}';

				this.$post(
					api.http_method, postdata
				).then(res => {
					res = JSON.parse(res);
					// //console.log(res);
					this.$message({
						message: res.data.msg,
						type: 'success'
					});

					this.load_db_data();

				});

			},
			fun_del_file_three: function() {
				// console.log('删除路径 \r\n' + this.file_src);
				var postdata = '';
				postdata =
					'{"method":"File_del","data":"' + base_encode(this.file_src) + '"}';
				this.$post(
					api.http_method, postdata
				).then(res => {

					res = JSON.parse(res);
					// console.log(res);
					if (res.data.status == 1) {

						this.$message({
							message: BackSpecial(BackSpecial(res.data.msg)),
							type: 'success'
						});

					} else {
						this.$message({
							message: BackSpecial(BackSpecial(res.data.msg)),
							type: 'warning'
						});
					}
				});
			},
			fun_up_file: async function() {
				// 一块文件的大小
				this.blockSize = 1 * 1024 * 1024;
				console.log('base64文件大小=' + this.file_data.length)
				if (this.file_data.length > 0 && this.file_data.length <= this.blockSize) {
					// console.log('小文件上传');
					this.fun_up_file_min();
				} else if (this.file_data.length > this.blockSize) {
					// console.log('大文件上传');
					// this.element_loading = true;
					let random_name = GetRandom();
					this.file_name = random_name + this.file_name;

					await this.fun_up_file_max();
					// this.element_loading = false;
				} else {
					this.$message({
						message: '未发现上传文件!',
						type: 'warning'
					});
				}
			},
			fun_up_file_min: function() {


				// //console.log('点击上传附件');
				if (this.p3 == '') {
					this.p3 = GetShort("userno");
				}
				// //console.log('p3=' + this.p3);
				this.element_loading = true;
				var postdata = "";

				postdata =
					'{"action":"' + this.file_action + '_add","user_no":"' +
					GetShort("userno") +
					'","upfile_name":"' +
					DeleteSpecialWord(DeleteSpecialWord(this.file_name)) +
					// '","upfile_type":"' +
					// this.file_type +
					// '","upfile_size":"' +
					// this.file_size +
					'","upfile_data":"' +
					this.file_data +
					'","rowid":"' +
					this.row_id +
					'","sheet_no":"' +
					this.check_key + '_' + this.row_id + '","p1":"' +
					this.p1 +
					'","p2":"' +
					this.p2 +
					'","p3":"' +
					this.p3 +
					'"}';

				// console.log(JSON.parse(postdata));

				postdata =
					'{"method":"File_load","data":"' + base_encode(postdata) + '"}';


				let that = this;
				var loaded = 0,
					total = 0;
				this.$postfile(
					api.http_method,
					postdata,
					res => {
						loaded = res.loaded;
						total = res.total;
						this.$nextTick(() => {
							that.file_up = ((loaded / total) * 100).toFixed(2) + " %";
						});
					}
				).then(res => {
					res = JSON.parse(res);
					res = res.data;
					this.element_loading = false;
					if (res.status == 1) {
						that.file_up = "上传成功";

						that.file_url = BackSpecial(res.f_url);
						that.file_src = BackSpecial(res.f_src);
						this.load_db_data();

						this.$message({
							message: '上传成功',
							type: 'success'
						});
					} else {
						this.file_up = "上传失败";

						this.$message({
							message: '上传失败\n\r' + res.msg,
							type: 'success'
						});
					}

				});


			},
			fun_up_file_max: async function() {
				// 大于1M，分段上传
				let num = 1;
				let start = 0;
				let end = 0;
				let maxFileLength = 0;
				maxFileLength = this.file_backdata.size;
				this.file_size = maxFileLength;
				// //console.log('原始文件总长度=' + maxFileLength + ' 标准块=' + this.blockSize);

				while (start < maxFileLength) {
					end = start + this.blockSize;
					if (end > maxFileLength) {
						end = maxFileLength;
					}


					let temp_data = '';
					temp_data = this.file_backdata.slice(start, end); //文件切片
					// //console.log('上传长度=' + temp_data.size);
					// //console.log(temp_data);
					// 上传出错则重新上传
					let res = '';
					try {
						res = await this.fun_up_file_block(temp_data);
						//console.log(res);
						if (res.status == 1) {
							this.file_up = '数据块' + (num + 1) + '完成 总进度:' + ((end / maxFileLength) * 100).toFixed(2) +
								" %";
						} else {
							// let maxTime = 3;
							// let min = 0
							// let resTwo = '';
							// while (min < maxTime) {
							//   resTwo = await this.fun_up_file_block(temp_data);
							//   if (resTwo.status != 1) {
							//     this.$message({
							//       message: '上传出错请稍后重新上传',
							//       type: 'success'
							//     });
							//   }
							//   min++;
							// }

						}
					} catch (error) {
						res = await this.fun_up_file_block(temp_data);
					}
					start = end;
					num++;
				}

				this.fun_up_file_savepath();
			},
			fun_up_file_block: async function(temp_data) {
				// //console.log('点击上传附件');
				if (this.p3 == '') {
					this.p3 = GetShort("userno");
				}
				// //console.log('p3=' + this.p3);
				let that = this;
				var postdata = "";

				let temp_filedata = await this.fun_blod_toString(temp_data);
				// 这里保存文件数据。因为是切片追加模式，而且不写路径。所以row_id和sheet_no 不用传
				postdata =
					'{"action":"' + 'data_save_' + this.file_action + '","user_no":"' +
					GetShort("userno") +
					'","upfile_name":"' +
					DeleteSpecialWord(DeleteSpecialWord(this.file_name)) +
					// '","upfile_type":"' +
					// this.file_type +
					'","upfile_size":"' +
					this.file_size +
					'","upfile_data":"' +
					temp_filedata +
					'","rowid":"' +
					this.row_id +
					'","sheet_no":"' +
					this.check_key + '_' + this.row_id + '","p1":"' +
					this.p1 +
					'","p2":"' +
					this.p2 +
					'","p3":"' +
					this.p3 +
					'"}';

				postdata =
					'{"method":"File_block","data":"' + base_encode(postdata) + '"}';

				return new Promise((resolve, reject) => {
					// //console.log(menuvalue);
					that.$post(
						api.http_method, postdata
					).then(res => {
						res = JSON.parse(res);
						// //console.log(res);

						resolve(res.data)
					})
				});

			},
			fun_blod_toString: function(fileData) {
				return new Promise((resolve, reject) => {

					let reader = new FileReader(); // FileReader
					reader.readAsDataURL(fileData);
					reader.onload = function() {
						// 获取到base64图片内容
						// //console.log(this.result);
						// let f='';
						// f=ChangeSpecial(this.result);
						// //console.log(f);
						resolve(this.result);
					}

				});
			},
			fun_up_file_savepath: function() {
				if (this.p3 == '') {
					this.p3 = GetShort("userno");
				}
				//console.log('p3=' + this.p3);
				this.element_loading = true;
				var postdata = "";

				postdata =
					'{"action":"' + this.file_action + '_add","user_no":"' +
					GetShort("userno") +
					'","upfile_name":"' +
					DeleteSpecialWord(DeleteSpecialWord(this.file_name)) +
					// '","upfile_type":"' +
					// this.file_type +
					'","upfile_path":"' +
					this.p1 + '/' + this.p2 + '/' + this.p3 + '/' + this.file_name +
					'","upfile_data":"' +
					'' +
					'","rowid":"' +
					this.row_id +
					'","sheet_no":"' +
					this.check_key + '_' + this.row_id + '"}';

				// //console.log(postdata);
				postdata =
					'{"method":"File_SavePath","data":"' + base_encode(postdata) + '"}';


				let that = this;
				this.$post(
					api.http_method,
					postdata
				).then(res => {
					res = JSON.parse(res);
					res = res.data;
					this.element_loading = false;
					if (res.status == 1) {
						that.file_up = "上传成功";

						that.file_url = BackSpecial(res.f_url);
						that.file_src = BackSpecial(res.f_src);

						that.fun_d_load();

						this.$message({
							message: '上传成功',
							type: 'success'
						});
					} else {
						this.file_up = "上传失败";

						this.$message({
							message: '上传失败\n\r' + res.msg,
							type: 'success'
						});
					}

				});

			},




		}
	};
</script>

<style scoped>
	/* 设置 倒数 第二、第三列 隐藏 */
	.last-two-none>td:nth-last-child(3),
	.last-two-none>td:nth-last-child(2) {
		display: none;
	}

	.last-two-none>td:nth-last-child(2) {
		display: none;
	}

	.tab-row {
		display: block;
		overflow: auto;
	}

	/* 编辑部分 */
	.menu-left {
		display: inline-block;
		/* width: 40%; */
		min-width: 400px;
		/* overflow: auto; */
		vertical-align: top;
		margin-right: 6px;
	}

	.menu-right {
		display: inline-block;
		width: 50%;
		min-width: 400px;
		/* overflow: auto; */
		vertical-align: top;
		margin-left: 6px;
	}

	.edit-area {
		display: flex;
		width: 100%;
		align-items: flex-start;
		justify-content: flex-start;
		padding: 8px;
	}

	.menu-title {
		font-size: 18px;
		text-align: center;
		font-weight: bold;
	}

	.menu-edit-all-l {
		display: flex;
		width: 100%;
		min-width: 640px;
		align-items: center;
		height: 36px;
	}

	.menu-edit-all-r {
		display: flex;
		width: 100%;
		min-width: 780px;
		align-items: center;
		height: 36px;
	}

	.menu-edit {
		display: inline-flex;
		width: auto;
		align-items: center;
	}

	.pre-tab {
		display: flex;
		width: 100%;
		min-width: 780px;
		align-items: center;
	}

	.checkleft {
		/* margin-left: -48px; */
		display: flex;
		align-items: center;
		justify-content: center;
	}
</style>